/**
 * The error reducer to handle sharing errors between components
 * @param {Object} initialState The initial state of the error object.
 * @returns {JSON} New state
 */
const createErrorReducer = (initialState = {}) => {
    return (state = initialState, action) => {
        const serverError = (action.errorPayload && action.errorPayload.response) || null;
        switch (action.type) {
            case 'SET_CURRENT_ERROR': {
                let key = 'internalError';
                if (serverError) {
                    key = 'serverError';
                }
                return state.set(key, action.errorPayload);
            }
            case 'CLEAR_CURRENT_ERROR': {
                return state.merge({ serverError: null, internalError: null });
            }
            default: {
                return state;
            }
        }
    };
};

export { createErrorReducer };
